import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// @material-ui/icons

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import InfoArea from "components/InfoArea/InfoArea.jsx";

import servicesStyle from "assets/jss/material-kit-pro-react/views/aboutUsSections/servicesStyle.jsx";

function SectionServices(props) {
  const { classes } = props;
  return (
    <div className={classes.services}>
      <GridContainer>
        <GridItem
          md={8}
          sm={8}
          className={classNames(
            classes.mlAuto,
            classes.mrAuto,
            classes.textCenter
          )}
        >
          <h2 className={classes.title}>What we offer</h2>
          <h5 className={classes.description}>
            Kinos’s partnership culture, our commitment to excellence and uncompromising integrity makes us an excellent choice for investors with a long-term vision.
          </h5>

          <h5 className={classes.description}>Our client´s interest first is the core of our asset management philosophy.
We also custom tailor your investment strategies to clients’ specific needs.
</h5>
        </GridItem>
      </GridContainer>
      <GridContainer>


        <GridItem md={12} sm={12}
          className={classNames(
            classes.mlAuto,
            classes.mrAuto,
            classes.textCenter
          )}
          >

        <h3 className={classes.title}>What areas we cover</h3>

        </GridItem>

        <GridItem md={6} sm={6}
          className={classNames(
            classes.mlAuto,
            classes.mrAuto,
            classes.textCenter
          )}
          >

            <span>
              <p>
                <h5>Commercial</h5>
                <h5>Office</h5>
                <h5>Residential</h5>
                <h5>Multifamily</h5>
                <h5>Retail</h5>
                <h5>Healthcare</h5>

              </p>

            </span>
        </GridItem>

        <GridItem md={6} sm={6}
          className={classNames(
            classes.mlAuto,
            classes.mrAuto,
            classes.textCenter
          )}
          >
            <span>

              <h5>Hotels and Resorts</h5>
              <h5>Industrial and Logistics</h5>
              <h5>Land</h5>
              <h5>Agribusiness</h5>
              <h5>Golf</h5>
              <h5>Green Building</h5>


            </span>
        </GridItem>

      </GridContainer>
    </div>
  );
}


export default withStyles(servicesStyle)(SectionServices);
